/**
 * The `initCartSync` function initializes a cart synchronization feature by fetching cart data,
 * listening for specific URLs related to cart changes, and updating the local and global cart data
 * accordingly.
 */
(async function initCartSync() {
  /**
   * The function `getCart` fetches a JSON file containing the cart data and returns it as a promise.
   * @returns The function `getCart()` returns a Promise that resolves to the JSON data fetched from
   * the "/cart.json" endpoint if the fetch request is successful (status code 200). If the fetch
   * request fails, it throws an Error with a message indicating the failure.
   */
  async function getCart() {
    const result = await fetch('/cart.json');

    if (result.status === 200) {
      return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }

  /**
   * The function `listenForCartChanges` overrides the `fetch` function in JavaScript to detect
   * specific URLs related to cart changes and update the local and global cart data.
   * @returns The function `listenForCartChanges` does not explicitly return anything.
   */
  function listenForCartChanges() {
    const cartUrls = [`${routes.cart_add_url}`, `${routes.cart_change_url}`];

    // Save the original fetch function
    const originalFetch = window.fetch;

    // Override the fetch function
    window.fetch = function (url, options) {
      // Call the original fetch function
      return originalFetch.apply(this, arguments).then(async (response) => {
        if (cartUrls.includes(url)) {
          console.info('Fetch request to specific URL detected:', url);

          // Fetch the updated cart data after the original fetch is completed
          const updatedCart = await getCart();

          // Update the local and global cart data
          cart = updatedCart;
          window.cart = updatedCart;

          // console.info('Saved updated cart data to `window.cart`');
          // updateCartCount();
          // updateCartProgressBar();
        }

        // Return the original response
        return response;
      });
    };
  }

  /**
   * The function `updateCartCount` updates the cart count displayed on the page based on the number
   * of items in the cart.
   */
  function updateCartCount() {
    if (window.location.pathname === `${routes.cart_url}`) {
      const cartCountElem = document.querySelector('.cart__heading--cart-count');
      if (cart.item_count === 1) {
        cartCountElem.innerHTML = `${cart.item_count} item`;
      } else {
        cartCountElem.innerHTML = `${cart.item_count} items`;
      }
    }
  }

  function updateCartProgressBar() {
    if (window.location.pathname === `${routes.cart_url}`) {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const progressBarUpdate = html.querySelector('.progress-bar-section').innerHTML;
          document.querySelector('.cart__footer .progress-bar-section').innerHTML = progressBarUpdate;
        });
    }
  }

  // function updateCartProgressBar() {
  //   if (window.location.pathname === `${routes.cart_url}`) {
  //     fetch(`${routes.cart_url}?section_id=main-cart-items`)
  //       .then((response) => response.text())
  //       .then((responseText) => {
  //         const html = new DOMParser().parseFromString(responseText, 'text/html');
  //         const progressBarUpdate = html.querySelector('.progress-bar-section').innerHTML
  //         document.querySelector('.cart__footer .progress-bar-section').innerHTML = progressBarUpdate
  //       })
  //   }
  // }

  /**
   * The function `refreshCartDrawer` fetches updated HTML content for a cart drawer element and
   * replaces the existing cart drawer element with the new content.
   * @returns a Promise.
   */
  async function refreshCartDrawer() {
    return await fetch('/?section_id=cart-drawer')
      .then((data) => {
        return data.text();
      })
      .then((res) => {
        const cartDrawerContainer = document.querySelector('cart-drawer');
        const oldCartDrawerElement = document.querySelector('.cart-drawer');
        const fragment = document.createDocumentFragment();
        const newCartDrawerElement = document.createElement('div');

        newCartDrawerElement.insertAdjacentHTML('afterbegin', res);
        fragment.appendChild(newCartDrawerElement.querySelector('.cart-drawer'));
        cartDrawerContainer.removeChild(oldCartDrawerElement);
        cartDrawerContainer.appendChild(fragment);
        console.info('Cart drawer refreshed');
      })
      .catch((e) => {
        console.error(e);
      });
  }

  /**
   * The `init` function initializes the CartSync feature by retrieving the cart data and storing it
   * in the `window.cart` variable.
   * @returns The `init` function is returning the `cart` object.
   */
  async function init() {
    const cart = await getCart();
    console.info('CartSync initiated, saving cart data to `window.cart.data`');
    window.cart = {};
    window.cart.data = cart;
    window.cart.refreshCartDrawer = refreshCartDrawer;
    window.cart.getCart = getCart;
    return cart;
  }

  // Initiate, then save current cart data
  let cart = await init();

  listenForCartChanges();
})();
